export const properties = {
    RESOURCE: 'sica',
    urlDatosPersonales: '/datosPersonales',
    urlInstituciones: '/institucionSica'
}